module.exports = __webpack_public_path__ + "img/320.2fba9842.png";